import { render, staticRenderFns } from "./SelectableRectangle.vue?vue&type=template&id=3621d162"
import script from "./SelectableRectangle.vue?vue&type=script&lang=js"
export * from "./SelectableRectangle.vue?vue&type=script&lang=js"
import style0 from "./SelectableRectangle.vue?vue&type=style&index=0&id=3621d162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports